export const MUTATION_DELETE_GT_CASE = /* GraphQL */ `
	mutation ($id: String!) {
		deleteGeneralTenantCase(id: $id)
	}
`;
